import { type IconName, icons } from '../components/icon/generated_icons';

export function isIconName(value: string): value is IconName {
  return value in icons;
}
